import { render, staticRenderFns } from "./PosterTextTitle.vue?vue&type=template&id=8344b536&scoped=true&"
import script from "./PosterTextTitle.vue?vue&type=script&lang=js&"
export * from "./PosterTextTitle.vue?vue&type=script&lang=js&"
import style0 from "./PosterTextTitle.vue?vue&type=style&index=0&id=8344b536&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8344b536",
  null
  
)

export default component.exports